import { computed, type Ref } from 'vue';
import type { FlightFilterState } from '@aviata/offers-filters-fns';
import { minutesToHours } from './lib';

export function useFlightTimeFilter(filterState: Ref<FlightFilterState>) {
  const transformTimeStateToHours = (time: number[]) =>
    time.map(minutesToHours);
  const transformedDepTime = computed(() =>
    transformTimeStateToHours(filterState.value.dep.time),
  );
  const transformedArrTime = computed(() =>
    transformTimeStateToHours(filterState.value.arr.time),
  );

  return {
    transformedArrTime,
    transformedDepTime,
  };
}
